type PossibleClasses = string | null | undefined | boolean;

export default (...classes: PossibleClasses[]): string => {
  const whitespace = /\s+/g;
  const validClasses = classes.filter((className) =>
    className ? className : ''
  );
  return validClasses.join(' ').replace(whitespace, ' ').trim();
};
